import { decryptString } from "@/utils/encryption"
import { URL_IMAGE } from "../types/constant"
import { Base64Utils } from "./base64"
import { Formatter } from "./formatter"

export const getImageUrl = (pathImage: string, image: string): string => {
	return `${URL_IMAGE}${pathImage}${image}`
}

type ImageSize = "lg" | "md" | "sd" | "sm" | "xs"

interface ImageData {
	image?: string
	path_image?: string
}

export function getImagePath(
	data: ImageData,
	type: "course" | "product" | "blog" | "app-store" | "app-image" = "course",
	size: ImageSize = "lg",
	isProxy = false,
): string {
	if (!data || !data.image) return "/images/LogoEMS.png"

	if (data.image === "") return "/images/LogoEMS.png"
	if (type === "blog") {
		return `${URL_IMAGE}${data.path_image}${data.image}`
	}
	if (type === "app-store") {
		return `${URL_IMAGE}${data.path_image}${data.image}`
	}
	if (type === "app-image") {
		if (!data.image) return "/images/LogoEMS.png"
		const image = data.image
		// console.log('image:', image)
		return image
	}

	const sizeMap: Record<ImageSize, string> = {
		lg: "maxresdefault",
		md: "hqdefault",
		sd: "sddefault",
		sm: "mqdefault",
		xs: "default",
	}
	if (isProxy) {
		if (!data.image) return "/images/LogoEMS.png"
		const image = data.image
		
		// Backend returns Base64-encoded URLs with key
		// Return as-is so ProxyImage can use it directly for API call
		// The Base64 string will be used as the URL parameter
		return image
	}
	// if (data.image.includes("http:") || data.image.includes("https:")) {
	// 	return `${URL_IMAGE}${data.path_image}${data.image}`
	// }
	if (!data.image) return "/images/LogoEMS.png"
	const image = data.image

	// if (image.includes("ytimg.com")) {
	// 	const ytImage = image
	// 		.replace("hqdefault.jpg", `${sizeMap[size]}.jpg`)
	// 		.replace("/vi/", "/vi_webp/")
	// 		.replace(".jpg", ".webp")

	// 	// Return the proxy URL with a data attribute to indicate it needs processing
	// 	return ytImage
	// }

	// if (type !== "product") {
	// 	return `${URL_IMAGE}${data.path_image}${image}`
	// }

	return `${URL_IMAGE}/${image}`
}

interface CurrentUser {
	avatar?: string
	path_image?: string
}

interface LecturerData {
	avatar?: string
	path_image?: string
}

export function getAvatarPath(data: any): string | undefined {
	if (!data) return
	if (!data?.user?.avatar) return "/images/ico.png"
	return `${URL_IMAGE}/${data.user.avatar}`
}

export function getCurrentUserAvatarPath(currentUser: CurrentUser): string {
	if (!currentUser || Formatter.isNull(currentUser.avatar))
		return "/icons/user-circle.svg"
	if (
		currentUser.avatar?.includes("http:") ||
		currentUser.avatar?.includes("https:")
	) {
		return currentUser.avatar
	}
	return `${URL_IMAGE}${currentUser.path_image ?? ""}${currentUser.avatar ?? ""}`
}

export function getLecturerPath(data: LecturerData): string {
	if (!data || !data.avatar) return "/images/ico.png"
	return `${URL_IMAGE}${data.path_image}${data.avatar}`
}

export const compressImage = async (
	file: File,
	maxSizeInBytes: number,
): Promise<File | null> => {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = (event) => {
			const img = new Image()
			img.src = event.target?.result as string
			img.onload = () => {
				const canvas = document.createElement("canvas")
				let width = img.width
				let height = img.height

				// Calculate new dimensions while maintaining aspect ratio
				if (width > height) {
					if (width > 1920) {
						height = Math.round((height * 1920) / width)
						width = 1920
					}
				} else {
					if (height > 1080) {
						width = Math.round((width * 1080) / height)
						height = 1080
					}
				}

				canvas.width = width
				canvas.height = height

				const ctx = canvas.getContext("2d")
				ctx?.drawImage(img, 0, 0, width, height)

				// Convert to WebP format with quality adjustment
				canvas.toBlob(
					(blob) => {
						if (!blob) {
							resolve(null)
							return
						}
						// If the compressed size is still larger than maxSize, reduce quality
						if (blob.size > maxSizeInBytes) {
							const quality = Math.min(0.8, (maxSizeInBytes / blob.size) * 0.9)
							canvas.toBlob(
								(finalBlob) => {
									if (!finalBlob) {
										resolve(null)
										return
									}
									resolve(
										new File([finalBlob], file.name, { type: "image/webp" }),
									)
								},
								"image/webp",
								quality,
							)
						} else {
							resolve(new File([blob], file.name, { type: "image/webp" }))
						}
					},
					"image/webp",
					0.9,
				)
			}
		}
		reader.onerror = () => resolve(null)
	})
}
